import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '@i18n';
import './language-switcher.scss';

/**
 * LanguageSwitcher - Dropdown component for switching application language
 *
 * Features:
 * - Dropdown select with supported languages
 * - Language preference persisted to localStorage
 * - Automatically updates all content when language changes
 * - Accessible with proper labels and ARIA attributes
 */
export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();

  const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newLanguage = e.target.value;
    i18n.changeLanguage(newLanguage);
  };

  return (
    <div className="language-switcher">
      <label htmlFor="language-select" className="language-switcher__label">
        {t('pages.sidebar.language')}
      </label>
      <select
        id="language-select"
        className="language-switcher__select"
        value={i18n.language}
        onChange={handleLanguageChange}
        aria-label={t('pages.sidebar.language')}
      >
        {SUPPORTED_LANGUAGES.map((lang) => (
          <option key={lang} value={lang}>
            {lang === 'it' ? 'Italiano' : 'English'}
          </option>
        ))}
      </select>
    </div>
  );
}

export default LanguageSwitcher;
